<template>
  <div class="calcFormsForm">
    <div v-if="loading">
      <v-progress-circular
        :size="20"
        color="primary"
        class="mr-2"
        indeterminate
      ></v-progress-circular>
      Loading...
    </div>
    <div v-else-if="investmentItem">
      <v-form ref="investmentForm" v-model="isFormValid" class="investmentItemForm" lazy-validation>
        <div>
          <v-text-field
            v-model="investmentItem.Name"
            label="Name"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-text-field
            v-model="investmentItem.Description"
            label="Description"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-model="investmentItem.ColumnName"
            label="Column  name"
            :items="availableColumns"
            :rules="rules"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="From date"
            v-model="investmentItem.StartDate"
            :rules="rules"
            append-icon="mdi-arrow-down-bold-box"
            :readonly="!showFormButtons"
            @click:append="openCalculationSelection('StartDate')"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="externalSelectionInput">
          <v-text-field
            label="To date"
            v-model="investmentItem.EndDate"
            :rules="rules"
            :readonly="!showFormButtons"
            append-icon="mdi-arrow-down-bold-box"
            @click:append="openCalculationSelection('EndDate')"
            dense
            outlined
          ></v-text-field>
        </div>
        <div>
          <v-select
            v-model="investmentItem.Manager"
            label="Manager"
            :items="availableManagers"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div v-if="isFundAvailable">
          <v-select
            v-model="investmentItem.Fund"
            label="Fund"
            :items="availableFunds"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="investmentItem.ContributionType"
            label="Contribution Type"
            :items="availableContributionTypes"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="investmentItem.TransactionType"
            label="Transaction Type"
            :items="availableTransactionTypes"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="investmentItem.ProfileType"
            label="Profile Type"
            :items="availableProfileTypes"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-select>
        </div>
        <div>
          <v-select
            v-model="investmentItem.Rounding"
            label="Rounding"
            :readonly="!showFormButtons"
            :items="availableRoundings"
            dense
            outlined
          ></v-select>
        </div>
        <div v-if="investmentItem.Rounding != 'None'">
          <v-text-field
            v-model="investmentItem.RoundAmount"
            label="Rounding Amount"
            type="number"
            min="0"
            :step="0.01"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
      </v-form>
      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <v-btn v-if="itemId" color="error" outlined @click="onDelete" class="mr-4">
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCopy" class="mr-4"> Copy </v-btn>

          <v-btn color="primary" outlined @click="onTest" class="mr-4"> Test </v-btn>
          <v-btn color="primary" outlined @click="onCancel" class="mr-4"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert type="info" outlined dense>No info found for this element</v-alert>
    </div>
    <Dialog ref="confirmationDialog" v-model="dialog" />
    <CalculationSelection
      ref="calculationSelection"
      @select="onSelect"
      :levelId="planId"
      :typeList="availableCalculationTypes"
    />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import CalculationSelection from './Popups/CalculationSelection.vue';

export default {
  name: 'InvestmentForm',
  components: {
    Dialog,
    CalculationSelection,
  },
  props: {
    itemId: { type: Number },
    planId: { type: Number },
  },
  created() {
    this.getManagerList();
    this.getGetContributionTypes();
    if (this.itemId) this.getInvestment(this.itemId);
    else this.createNewInvestment();
  },
  data() {
    return {
      loading: false,
      isFormValid: false,
      dialog: false,
      investmentItem: null,
      rules: [(value) => !!value || 'Required.'],
      availableColumns: ['Contributions', 'Units', 'Value'],
      availableManagers: [{ value: 0, text: 'All' }],
      availableFunds: [],
      availableContributionTypes: ['All'],
      availableTransactionTypes: [
        '',
        'All',
        'Regular Contribution',
        'Maintenance Charge',
        'Transfer In',
        'Leaver Sell',
      ],
      availableProfileTypes: [
        { value: 'All', text: 'All' },
        { value: 'Regular', text: 'Regular Contribution' },
        { value: 'TransferIn', text: 'Transfer In' },
      ],
      availableRoundings: ['None', 'Nearest', 'Highest', 'Lowest'],
      showSelectItem: true,
      calculationSelectionProperty: null,
      availableCalculationTypes: ['Dates', 'Inputs'],
    };
  },

  computed: {
    selectedManager() {
      return this.investmentItem ? this.investmentItem.Manager : 0;
    },
    isFundAvailable() {
      return this.investmentItem && this.investmentItem.Manager > 0;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    itemId: function () {
      if (this.itemId) this.getInvestment(this.itemId);
      else this.createNewInvestment();
    },
    selectedManager: function () {
      this.availableFunds = [];
      //his.investmentItem.Fund = 0;
      if (this.investmentItem.Manager > 0) {
        this.getFundList();
      } else {
        this.investmentItem.Fund = 0;
      }
    },
  },

  methods: {
    onCopy() {
      const isFormValid = this.$refs.investmentForm.validate();
      if (isFormValid) this.copyData();
    },
    async copyData() {
      try {
        let response = await this.$api.post('/CalculationItem/CopySalaryItem', this.investmentItem);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Item was copied',
        });
        this.$emit('reloadList', 'update', response.data.Value);
      } catch (err) {
        console.error(err);
      }
    },
    createNewInvestment() {
      this.investmentItem = {
        ArrayId: 0,
        CalcId: 0,
        StartDate: '',
        EndDate: '',
        Selector: '',
        Filter: '',
        TableName: 'Transactions',
        ColumnName: 'Value',
        Valued: '',
        Term: 0,
        Bestn: 0,
        Manager: 0,
        Fund: 0,
        ContributionType: 'All',
        TransactionType: 'Leaver Sell',
        ProfileType: 'All',
        Adjustment: '',
        AtAnniversary: '',
        PlanId: this.planId,
        GroupId: 0,
        Name: '',
        Description: '',
        CalcType: 'Investment',
        Expression: null,
        Rounding: 'None',
        RoundAmount: 0,
        RoundPeriod: null,
        Tag: null,
        Level: '',
        Username: null,
        DateChanged: '',
      };
    },

    onCancel() {
      if (this.itemId) this.getInvestment(this.itemId);
      else this.createNewInvestment();
    },

    onSave() {
      const isFormValid = this.$refs.investmentForm.validate();
      if (isFormValid) this.saveData();
    },

    onTest() {
      this.$emit('setTestMode');
    },

    openCalculationSelection(property) {
      if (!this.showFormButtons) return;
      this.calculationSelectionProperty = property;
      this.availableCalculationTypes = property == 'Adjustment' ? ['Other'] : ['Dates', 'Inputs'];
      const selectDialog = this.$refs.calculationSelection;
      selectDialog.open();
    },
    onSelect(val) {
      this.investmentItem[this.calculationSelectionProperty] = val;
      this.calculationSelectionProperty = null;
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteInvestment();
      } catch (err) {
        console.log();
      }
    },
    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        const data = response.data;
        if (data && data.length > 0) {
          const insertIndex = 1;
          data.forEach((manager) => {
            this.availableManagers.splice(insertIndex, 0, {
              value: manager.ManagerId,
              text: manager.ManagerName,
            });
          });
        }
      } catch (err) {
        console.error(err);
      }
    },

    async getFundList() {
      try {
        const response = await this.$api.get(
          '/Funds/GetFundList?managerId=' + this.investmentItem.Manager
        );

        if (response.data && response.data.length > 0) {
          response.data.forEach((fund) => {
            this.availableFunds.push({ value: fund.PortfolioId, text: fund.PortfolioName });
          });
        }

        if (!this.availableFunds.find(x => x.value === this.investmentItem.Fund)){
          this.investmentItem.Fund = 0;
        }

      } catch (error) {
        console.log(error.message);
        this.investmentItem.Fund = 0;
      }
    },
    async getGetContributionTypes() {
      try {
        let response = await this.$api.get('/SalaryArray/GetContributionTypes');

        const data = response.data;
        if (data && data.length > 0) {
          data.forEach((x) => {
            this.availableContributionTypes.push(x);
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getInvestment() {
      if (this.itemId) {
        this.loading = true;
        this.investmentItem = null;
        console.log(this.itemId);
        try {
          let response = await this.$api.get(
            '/CalculationInvestment/GetInvestmentItem?id=' + this.itemId
          );

          if (!response.data) {
            const msg = 'Unable to load investment with id ' + this.itemId;
            this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
            throw new Error(msg);
          }

          var data = response.data;
          this.investmentItem = data;
        } catch (err) {
          this.$store.commit('setNotificationMessage', {
            type: 'error',
            text: 'Something went wrong.',
          });
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },

    async saveData() {
      this.updateInvestment();
    },

    async updateInvestment() {
      try {
        console.log(this.investmentItem);
        let response = await this.$api.post(
          '/CalculationInvestment/UpdateInvestmentItem',
          this.investmentItem
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Investment was saved',
        });
        if (this.investmentItem.CalcId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
        }
        this.getInvestment();
      } catch (err) {
        console.error(err);
      }
    },

    async deleteInvestment() {
      try {
        await this.$api.delete('/CalculationInvestment/DeleteInvestmentItem?id=' + this.itemId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Element is deleted',
        });
        this.$emit('reloadList', 'delete');
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.calcFormsForm {
  .externalSelectionInput {
    display: flex;

    .selectIcon {
      margin-top: -25px;
    }
  }
}
</style>
